/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTokenSubstitute200Response
 */
export interface GetTokenSubstitute200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetTokenSubstitute200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetTokenSubstitute200Response
     */
    message: string;
    /**
     * 発行トークン
     * @type {string}
     * @memberof GetTokenSubstitute200Response
     */
    adminToken: string;
}

/**
 * Check if a given object implements the GetTokenSubstitute200Response interface.
 */
export function instanceOfGetTokenSubstitute200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "adminToken" in value;

    return isInstance;
}

export function GetTokenSubstitute200ResponseFromJSON(json: any): GetTokenSubstitute200Response {
    return GetTokenSubstitute200ResponseFromJSONTyped(json, false);
}

export function GetTokenSubstitute200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTokenSubstitute200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'adminToken': json['admin_token'],
    };
}

export function GetTokenSubstitute200ResponseToJSON(value?: GetTokenSubstitute200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'admin_token': value.adminToken,
    };
}

